import {
  type ApiClientPair,
  type Client,
  type ClientMiddleware,
  type ClientOptions,
  createApiClients,
  type UntypedApiClient,
} from '@asset-metrix/openapi-client-core';

import type { components, paths } from './schema.js';

export type ApiClient = Client<paths>;
export type Schemas = components['schemas'];
export type { ClientMiddleware, components, UntypedApiClient };

export function createApiClient(
  options: ClientOptions,
  middlewares?: ClientMiddleware[]
): ApiClientPair<paths> {
  return createApiClients<paths>(options, middlewares);
}
